// extracted by mini-css-extract-plugin
export default {"axis":"Axis_axis__DHso2","cell":"Axis_cell__DQgLN"};